import React from 'react'
import {alpha, Box, Typography, useTheme} from '@mui/material'
import ActionIconButton from 'src/components-new/primitives/ActionIconButton'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface ListItemRowProps {
  icon: React.ReactNode
  title: string
  subtitle: string
  status?: string
  statusIcon?: React.ReactNode
  onDownload?: () => void
  downloadLabel?: string
  onClick?: () => void
}

export default function ListItemRow({icon, title, subtitle, status, statusIcon, onDownload, downloadLabel = 'Scarica documento', onClick}: ListItemRowProps) {
  const theme = useTheme()
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        py: 1,
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: 1,
        '&:hover': onClick ? {backgroundColor: NEUTRAL_SCALE[50]} : undefined,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 1.5,
          backgroundColor: alpha(theme.palette.primary.main, 0.15),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: theme.palette.primary.main,
        }}
      >
        {icon}
      </Box>
      <Box sx={{minWidth: 0, flex: 1}}>
        <Typography
          variant='body1'
          sx={{
            fontWeight: 600,
            color: NEUTRAL_SCALE[900],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: {xs: 'normal', md: 'nowrap'},
            wordBreak: 'break-word',
          }}
        >
          {title}
        </Typography>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25}}>
          {statusIcon}
          <Typography variant='body2' color='text.secondary' sx={{lineHeight: 1.4}}>
            {status ? `${status}${subtitle ? ' · ' + subtitle : ''}` : subtitle}
          </Typography>
        </Box>
      </Box>
      {onDownload && (
        <ActionIconButton
          variant="download"
          onClick={e => {e.stopPropagation(); onDownload()}}
          aria-label={downloadLabel}
          sx={{flexShrink: 0, color: theme.palette.primary.main}}
        />
      )}
    </Box>
  )
}
